import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";

import { ConfirmationDialog } from "ui/confirmation-dialog";

import { getDisplayTouchpointType, getTouchpointType } from "utilities";

interface ConfirmArchiveModalProps {
  currentTouchpoint?: TouchpointVersionAttributes;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmArchiveModal = ({
  currentTouchpoint,
  isOpen,
  onClose,
  onSubmit,
}: ConfirmArchiveModalProps) => {
  if (!currentTouchpoint) return null;

  const touchpointType = getTouchpointType(currentTouchpoint);
  const formattedTouchpointType = getDisplayTouchpointType(touchpointType).toLowerCase();

  const MESSAGE = `Are you sure you want to archive ${formattedTouchpointType} draft version ${currentTouchpoint.version}?`;

  const ACCEPT_BUTTON_TEXT = "Archive draft";
  const REJECT_BUTTON_TEXT = "Cancel";

  return (
    <ConfirmationDialog
      open={isOpen}
      onClose={onClose}
      headline={MESSAGE}
      cancelButtonText={REJECT_BUTTON_TEXT}
      confirmButtonText={ACCEPT_BUTTON_TEXT}
      onConfirm={onSubmit}
      intent="error"
    />
  );
};

export default ConfirmArchiveModal;
